import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd659bde"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/certifications" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.article ? $options.article.title : ''), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          ($options.article)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_ion_img, {
                  alt: "Image",
                  src: $options.article.image_path,
                  style: {"max-width":"100%"}
                }, null, 8, ["src"]),
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.article.title), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.article.subtitle), 1),
                        _hoisted_1,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.article.tags, (tag, tagIndex) => {
                          return (_openBlock(), _createBlock(_component_ion_badge, {
                            style: {"margin-right":"5px","margin-top":"5px"},
                            key: 'tag_'+tagIndex
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: $options.article.content
                    }, null, 8, _hoisted_2),
                    ($options.article.link)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 0,
                          shape: "round",
                          expand: "block",
                          href: $options.article.link
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Vai al sito  "),
                            _createVNode(_component_ion_icon, { icon: $setup.exitOutline }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}